/**
 * Created by AlexanderC on 5/25/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Interface = undefined;

var _MethodsNotImplementedException = require('../Exception/MethodsNotImplementedException');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Interface implementation
 */
let Interface =
/**
 * @param {String[]|String} abstractMethods
 */
exports.Interface = function Interface() {
  _classCallCheck(this, Interface);

  for (var _len = arguments.length, abstractMethods = Array(_len), _key = 0; _key < _len; _key++) {
    abstractMethods[_key] = arguments[_key];
  }

  let methods = abstractMethods.length === 1 && abstractMethods[0] instanceof Array ? abstractMethods[0] : abstractMethods;

  let notImplementedMethods = [];

  for (let abstractMethodKey in methods) {
    if (!methods.hasOwnProperty(abstractMethodKey)) {
      continue;
    }

    let abstractMethod = methods[abstractMethodKey];
    if (!(this[abstractMethod] instanceof Function)) {
      notImplementedMethods.push(abstractMethod);
    }
  }

  if (notImplementedMethods.length > 0) {
    throw new _MethodsNotImplementedException.MethodsNotImplementedException(notImplementedMethods);
  }
};


//////////////////
// WEBPACK FOOTER
// ../~/deep-core/lib.compiled/OOP/Interface.js
// module id = 92
// module chunks = 0